import { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import moment from "moment";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Dialog,
  Typography,
  IconButton,
  ThemeProvider,
  createTheme,
  useTheme,
  Alert,
  Badge,
  Chip,
  Card,
  CardContent,
  Grid,
  TextField,
  InputAdornment,
  Divider,
  Paper,
  Avatar,
  Tab,
  Tabs,
  Pagination,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import ArticleIcon from "@mui/icons-material/Article";
import ForumIcon from "@mui/icons-material/Forum";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CandidatosForm from "./CandidatosForm";
import UpdatedUploadFiles from "../../../services/UpdatedUploadFiles";
import Entrevistas from "../entrevistas/Entrevistas";
import EvaluacionesMedicas from "../evaluacionesMedicas/EvaluacionesMedicas";
import ReferenciasLaborales from "../referenciasLaborales/ReferenciasLaborales";
import SeleccionarCandidato from "./SeleccionarCandidato";
import CandidatosDelete from "./CandidatosDelete";
import RechazarCandidatos from "./RechazarCandidatos";
import ModalCambioSolicitud from "../solicitudDePersonal/ModalCambioSolicitud";
import NotasModal from "../notas/NotasModal";

const Candidatos = ({ rowInfo, open, setOpen }) => {
  const { id, puesto, sucursal } = rowInfo;
  const globalTheme = useTheme();
  const [abrirModalDeNotas, setAbrirModalDeNotas] = useState(false);
  const [openModalRechazo, setOpenModalRechazo] = useState(false);
  const [candidatos, setCandidatos] = useState([]);
  const [filteredCandidatos, setFilteredCandidatos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [openFormModal, setOpenFormModal] = useState(false);
  const [openEntrevistasModal, setOpenEntrevistasModal] = useState(false);
  const [openEvaluacionesModal, setOpenEvaluacionesModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openSeleccionarCandidatoModal, setOpenSeleccionarCandidatoModal] =
    useState(false);
  const [openReferenciasLaboralesModal, setOpenReferenciasLaboralesModal] =
    useState(false);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [rowInfoEntrevistas, setRowInfoEntrevistas] = useState([]);
  const [idCandidato, setIdCandidato] = useState(-1);
  const [idInterview, setIdInterview] = useState(-1);
  const [idSeleccionarCandidato, setIdSeleccionarCandidato] = useState(-1);
  const [idToDelete, setIdToDelete] = useState(-1);
  const [rowInfoCandidatos, setRowInfoCandidatos] = useState({});
  const [openModalAdj, setOpenModalAdj] = useState(false);
  const [newUuid, setNewUuid] = useState("");
  const [abrirCambioDeSolicitud, setAbrirCambioDeSolicitud] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentTab, setCurrentTab] = useState(0);
  const [page, setPage] = useState(1);
  const itemsPerPage = 9;
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentCandidato, setCurrentCandidato] = useState(null);
  const [nombreCandidato, setNombreCandidato] = useState("");

  const RRHH = localStorage.getItem("adminrrhh");
  const USER = localStorage.getItem("user");

  const handleAbrirModalDeNotas = (id, nombre) => {
    setIdCandidato(id);
    setNombreCandidato(nombre);
    setAbrirModalDeNotas(true);
  };
  const tableTheme = createTheme({
    palette: {
      mode: globalTheme.palette.mode,
      primary: globalTheme.palette.primary,
      info: {
        main: "rgb(255,122,0)",
      },
      background: {
        default:
          globalTheme.palette.mode === "light" ? "rgb(234, 239, 241)" : "#000",
      },
    },
    typography: {
      button: {
        textTransform: "none",
        fontSize: "1rem",
      },
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: "0.8rem",
          },
        },
      },
    },
  });

  const abrirModalDeCambio = (id) => {
    setIdCandidato(id);
    setAbrirCambioDeSolicitud(true);
  };

  const handleOpenModalRechazo = (id) => {
    setIdCandidato(id);
    setOpenModalRechazo(true);
  };

  const obtenerCandidatos = async () => {
    try {
      setLoading(true);
      const response = await fetch(UrlApi + `/SP_candidatos/solicitud/${id}`);

      if (!response.ok) {
        throw new Error("Error al obtener los datos");
      }

      const data = await response.json();
      setCandidatos(data);
      setFilteredCandidatos(data);
    } catch (error) {
      console.error("Error obteniendo candidatos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtenerCandidatos();
  }, []);

  useEffect(() => {
    let filtered = [...candidatos];

    if (searchTerm) {
      filtered = filtered.filter(
        (candidato) =>
          candidato.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
          candidato.apellido.toLowerCase().includes(searchTerm.toLowerCase()) ||
          candidato.dni.toLowerCase().includes(searchTerm.toLowerCase()) ||
          candidato.mail.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    if (currentTab === 1) {
      filtered = filtered.filter((candidato) => candidato.estado === 2);
    } else if (currentTab === 2) {
      filtered = filtered.filter((candidato) => candidato.estado === 0);
    } else if (currentTab === 3) {
      filtered = filtered.filter(
        (candidato) => candidato.estado !== 0 && candidato.estado !== 2
      );
    }

    setFilteredCandidatos(filtered);
  }, [searchTerm, candidatos, currentTab]);

  const openSeleccionarCandiato = (id_candidato) => {
    setIdSeleccionarCandidato(id_candidato);
    setOpenSeleccionarCandidatoModal(true);
  };

  const handleOpenDeleteModal = (id) => {
    setIdToDelete(id);
    setOpenDeleteModal(true);
  };

  const mostrarAlertaTemporal = (mensaje, severidad) => {
    setMostrarAlerta(true);
    setMessage(mensaje);
    setSeverity(severidad);

    setTimeout(() => setMostrarAlerta(false), 5000);
  };

  const toggleModal = () => setOpenFormModal(!openFormModal);

  const openEntrevistaModal = (rowInfo) => {
    setRowInfoEntrevistas(rowInfo);
    setOpenEntrevistasModal(true);
  };

  const openReferenciasModal = (id) => {
    setIdCandidato(id);
    setOpenReferenciasLaboralesModal(true);
  };

  const handleOpenMedicalInterview = (id) => {
    setOpenEvaluacionesModal(true);
    setIdInterview(id);
  };

  const handleToogleModalAdj = async (uuid) => {
    setOpenModalAdj(!openModalAdj);
    setNewUuid(uuid);
  };

  const handleClose = () => setOpen(false);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    setPage(1);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleMenuOpen = (event, candidato) => {
    setAnchorEl(event.currentTarget);
    setCurrentCandidato(candidato);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentCandidato(null);
  };

  const paginatedCandidatos = filteredCandidatos.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const pageCount = Math.ceil(filteredCandidatos.length / itemsPerPage);

  const getStatusColor = (estado) => {
    if (estado === 0) return "#efc3c3";
    if (estado === 2) return "#b3e6b3";
    return "#f1f1f1";
  };

  return (
    <>
      <NotasModal
        open={abrirModalDeNotas}
        candidatoId={idCandidato}
        candidatoNombre={nombreCandidato}
        onClose={() => {
          obtenerCandidatos();
          setAbrirModalDeNotas(false);
          setCurrentCandidato(null);
        }}
      />

      {abrirCambioDeSolicitud && (
        <ModalCambioSolicitud
          idCandidato={idCandidato}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          open={abrirCambioDeSolicitud}
          onClose={() => setAbrirCambioDeSolicitud(false)}
          obtenerCandidatos={obtenerCandidatos}
        />
      )}
      {openModalRechazo && (
        <RechazarCandidatos
          onClose={() => setOpenModalRechazo(false)}
          open={openModalRechazo}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          id_candidato={idCandidato}
          obtenerCandidatos={obtenerCandidatos}
        />
      )}
      {openDeleteModal && (
        <CandidatosDelete
          id_candidato={idToDelete}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          obtenerCandidatos={obtenerCandidatos}
        />
      )}
      {openEntrevistasModal && (
        <Entrevistas
          puestoQueAplica={puesto.split(" ")[0]}
          rowInfo={rowInfoEntrevistas}
          handleClose={() => {
            obtenerCandidatos();
            setOpenEntrevistasModal(false);
          }}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          obtenerCandidatos={obtenerCandidatos}
        />
      )}
      {openEvaluacionesModal && (
        <EvaluacionesMedicas
          open={openEvaluacionesModal}
          id={idInterview}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          handleClose={() => {
            obtenerCandidatos();
            setOpenEvaluacionesModal(false);
          }}
        />
      )}
      {openReferenciasLaboralesModal && (
        <ReferenciasLaborales
          open={openReferenciasLaboralesModal}
          id_candidato={idCandidato}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          handleClose={() => {
            obtenerCandidatos();
            setOpenReferenciasLaboralesModal(false);
          }}
        />
      )}
      {mostrarAlerta && (
        <Alert
          severity={severity}
          sx={{
            zIndex: 1600,
            position: "fixed",
            top: "20px",
            right: "20px",
            width: "auto",
            borderRadius: "8px",
            backgroundColor:
              severity === "success"
                ? "#d8e6d3"
                : severity === "error"
                ? "#efc3c3"
                : severity === "warning"
                ? "#f0efb6"
                : "#e6e6e6",
          }}
        >
          {message}
        </Alert>
      )}
      {openSeleccionarCandidatoModal && (
        <SeleccionarCandidato
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          id_candidato={idSeleccionarCandidato}
          open={openSeleccionarCandidatoModal}
          onClose={() => setOpenSeleccionarCandidatoModal(false)}
          obtenerCandidatos={obtenerCandidatos}
        />
      )}
      {openModalAdj && (
        <UpdatedUploadFiles
          fileId={newUuid}
          open={openModalAdj}
          setOpen={setOpenModalAdj}
          readOnly={false}
          onClose={() => setOpenModalAdj(false)}
        />
      )}
      {openFormModal && (
        <CandidatosForm
          obtenerCandidatos={obtenerCandidatos}
          isEditMode={isEditMode}
          handleOpenCloseModalForm={() => setOpenFormModal(false)}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          rowInfo={rowInfoCandidatos}
          idSolicitudQueAplica={id}
        />
      )}

      <Dialog fullScreen open={open} onClose={handleClose}>
        <ThemeProvider theme={tableTheme}>
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Box
                sx={{
                  ml: 2,
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography variant="h6" component="div">
                  Numero de solicitud: {id} <br /> Candidatos del puesto:{" "}
                  {puesto}
                  <br /> Sucursal: {sucursal}
                </Typography>
              </Box>
            </Toolbar>
          </AppBar>

          <Box sx={{ p: 3 }}>
            <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    placeholder="Buscar candidatos..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                  }}
                >
                  <Button
                    variant="contained"
                    color="success"
                    startIcon={<AddBoxTwoToneIcon />}
                    onClick={() => {
                      setIsEditMode(false);
                      toggleModal();
                    }}
                  >
                    Añadir candidato
                  </Button>
                </Grid>
              </Grid>
            </Paper>

            <Paper elevation={2} sx={{ mb: 3 }}>
              <Tabs
                value={currentTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ borderBottom: 1, borderColor: "divider" }}
              >
                <Tab label="Todos" />
                <Tab label="Seleccionados" />
                <Tab label="Rechazados" />
                <Tab label="Pendientes" />
              </Tabs>
            </Paper>

            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <Typography>Cargando candidatos...</Typography>
              </Box>
            ) : paginatedCandidatos.length === 0 ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <Typography>No hay candidatos para mostrar</Typography>
              </Box>
            ) : (
              <Grid container spacing={3}>
                {paginatedCandidatos.map((candidato) => (
                  <Grid item xs={12} sm={6} md={4} key={candidato.id}>
                    <Card
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: getStatusColor(candidato.estado),
                      }}
                    >
                      <CardContent sx={{ flexGrow: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            mb: 2,
                          }}
                        >
                          <Avatar sx={{ bgcolor: "#2471A3", mr: 2 }}>
                            <PersonIcon />
                          </Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant="h6" component="div">
                              {candidato.nombre} {candidato.apellido}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              DNI: {candidato.dni}
                            </Typography>
                          </Box>
                          <IconButton
                            size="small"
                            onClick={(e) => handleMenuOpen(e, candidato)}
                            aria-label="más opciones"
                            sx={{ mt: -0.5 }}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </Box>

                        <Divider sx={{ my: 1.5 }} />

                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2">
                            <strong>Email:</strong> {candidato.mail}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Teléfono:</strong> {candidato.telefono}
                          </Typography>
                          {candidato.fecha_proxima && (
                            <Typography variant="body2">
                              <strong>Proxima entrevista:</strong>{" "}
                              {moment(candidato.fecha_proxima).format(
                                "DD/MM/YYYY HH:mm"
                              )}
                            </Typography>
                          )}
                          {candidato.motivo && (
                            <Typography variant="body2">
                              <strong>Motivo de rechazo:</strong>{" "}
                              {candidato.motivo}
                            </Typography>
                          )}
                        </Box>

                        {RRHH === "1" &&
                          candidato.evaluacion_evaluada === 0 && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                my: 1.5,
                              }}
                            >
                              <NotificationsNoneIcon color="primary" />
                              <Chip
                                label="Notificación médica"
                                color="primary"
                                size="small"
                                sx={{ ml: 1 }}
                              />
                            </Box>
                          )}

                        <Divider sx={{ my: 1.5 }} />

                        <Stack
                          direction="row"
                          spacing={1}
                          justifyContent="center"
                        >
                          <Badge
                            color="secondary"
                            badgeContent={candidato.cantidad_archivos ?? 0}
                            showZero
                            sx={{
                              "& .MuiBadge-badge": {
                                background: "#09b500",
                                color: "white",
                                fontSize: "0.75rem",
                                minWidth: "17px",
                                height: "17px",
                              },
                            }}
                          >
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleToogleModalAdj(candidato.uuid_archivo)
                              }
                              title="Mostrar CV"
                            >
                              <ArticleIcon sx={{ color: "#09b500" }} />
                            </IconButton>
                          </Badge>

                          <Badge
                            color="secondary"
                            badgeContent={candidato.cantidad_entrevistas ?? 0}
                            showZero
                            sx={{
                              "& .MuiBadge-badge": {
                                background: "#2b72ff",
                                color: "white",
                                fontSize: "0.75rem",
                                minWidth: "17px",
                                height: "17px",
                              },
                            }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => openEntrevistaModal(candidato)}
                              title="Entrevistas"
                            >
                              <ForumIcon sx={{ color: "#2b72ff" }} />
                            </IconButton>
                          </Badge>

                          <Badge
                            color="secondary"
                            badgeContent={candidato.cantidad_evaluaciones ?? 0}
                            showZero
                            sx={{
                              "& .MuiBadge-badge": {
                                background: "#ff2b2b",
                                color: "white",
                                fontSize: "0.75rem",
                                minWidth: "17px",
                                height: "17px",
                              },
                            }}
                          >
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleOpenMedicalInterview(candidato.id)
                              }
                              title="Evaluación Médica"
                            >
                              <LocalHospitalIcon sx={{ color: "#ff2b2b" }} />
                            </IconButton>
                          </Badge>

                          {RRHH === "1" && (
                            <Badge
                              color="secondary"
                              badgeContent={candidato.cantidad_referencias ?? 0}
                              showZero
                              sx={{
                                "& .MuiBadge-badge": {
                                  background: "#8800ff",
                                  color: "white",
                                  fontSize: "0.75rem",
                                  minWidth: "17px",
                                  height: "17px",
                                },
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={() =>
                                  openReferenciasModal(candidato.id)
                                }
                                title="Referencias laborales"
                              >
                                <Diversity3Icon sx={{ color: "#8800ff" }} />
                              </IconButton>
                            </Badge>
                          )}
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            )}

            {pageCount > 1 && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <Pagination
                  count={pageCount}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Box>
            )}
          </Box>
        </ThemeProvider>
      </Dialog>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          elevation: 3,
          sx: { width: 220, maxWidth: "100%" },
        }}
      >
        {(RRHH === "1" || currentCandidato?.user === USER) && (
          <MenuItem
            onClick={() => {
              setIsEditMode(true);
              setRowInfoCandidatos(currentCandidato);
              toggleModal();
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <EditIcon sx={{ color: "#8c8c8c" }} />
            </ListItemIcon>
            <ListItemText primary="Editar candidato" />
          </MenuItem>
        )}

        {RRHH === "1" && currentCandidato?.estado !== 2 && (
          <MenuItem
            onClick={() => {
              openSeleccionarCandiato(currentCandidato?.id);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <DoneIcon sx={{ color: "#0c7d04" }} />
            </ListItemIcon>
            <ListItemText primary="Seleccionar candidato" />
          </MenuItem>
        )}

        {RRHH === "1" && currentCandidato?.estado !== 2 && (
          <MenuItem
            onClick={() => {
              handleOpenDeleteModal(currentCandidato?.id);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <ClearIcon sx={{ color: "#9e0005" }} />
            </ListItemIcon>
            <ListItemText primary="Eliminar candidato" />
          </MenuItem>
        )}

        {RRHH === "1" && currentCandidato?.estado !== 2 && (
          <MenuItem
            onClick={() => {
              handleOpenModalRechazo(currentCandidato?.id);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <PersonRemoveIcon sx={{ color: "red" }} />
            </ListItemIcon>
            <ListItemText primary="Rechazar candidato" />
          </MenuItem>
        )}

        {RRHH === "1" && (
          <MenuItem
            onClick={() => {
              abrirModalDeCambio(currentCandidato?.id);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <ChangeCircleIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Cambiar solicitud" />
          </MenuItem>
        )}
        {RRHH === "1" && (
          <MenuItem
            onClick={() => {
              console.log(currentCandidato);
              handleAbrirModalDeNotas(
                currentCandidato.id,
                currentCandidato.nombreApellido
              );
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <StickyNote2Icon color="warning" />
            </ListItemIcon>
            <ListItemText primary="Ver notas" />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default Candidatos;
